// iOS Safari scroll fix - use display: contents on main
// it could break the layout in unexpected ways because it removes the <main> element from the rendering tree entirely. It might cause:
// Flexbox/grid layouts to break
// Spacing/margins to collapse incorrectly
// Accessibility issues (screen readers might skip the main landmark)
// Other CSS targeting main to not work
(function() {
  if (!/iPhone|iPad|iPod/.test(navigator.userAgent)) return;
  
  const fixScroll = () => {
    const main = document.querySelector('main');
    if (main) {
      main.style.setProperty('display', 'contents', 'important');
    }
  };
  
  // Apply immediately and after load
  fixScroll();
  window.addEventListener('load', fixScroll);
  document.addEventListener('DOMContentLoaded', fixScroll);
})();


// Safari iOS select fix for Mageworx APO
function mwApoCustom() {
  window.mwApoInit = window.mwApoInit || {};

  function onChange(el) {
    let evt = document.createEvent("HTMLEvents");
    evt.initEvent("change", false, true);
    el.dispatchEvent(evt);
  }

  function updateDropdown(params) {
    let dropdowns = document.querySelectorAll(".mw-option--type-select");
    dropdowns.forEach((element) => {
      let customSel = element.querySelector('.mws-new_select');
      if (customSel) {
        customSel.remove();
      }
      let select = element.querySelector(".mw-option__control--type-select");
      let value = select.value;
      let parentBlock = select.parentElement;
      let allNotHiddenElements = select.querySelectorAll('option');
      let notHidden = [];
      allNotHiddenElements.forEach(el => {
        let hidden = el.getAttribute('hidden');
        if (hidden === null) {
          notHidden.push(el.cloneNode(true));
        }
      });

      let newSelect = document.createElement("select");
      newSelect.classList.add('mws-new_select');
      notHidden.forEach(option => {
        newSelect.append(option);
      });
      newSelect.value = value;

      newSelect.addEventListener('change', (e) => {
        let newVal = e.target.value;
        select.value = newVal;
        onChange(select);
      });
      select.style.display = 'none';
      parentBlock.append(newSelect);
    });
  }

  window.mwApoInit.onCallback = function (event, data) {
    if (event == "applyAttributeStateToHtml::price") {
      updateDropdown();
    }
    return data;
  };
}

// Run the function
mwApoCustom();


function toggleAccordion(panelToActivate) {
	const activeButton = panelToActivate.querySelector('button');
	const activePanel = panelToActivate.querySelector('.accordion-content');
	const activePanelIsOpened = activeButton.getAttribute('aria-expanded');

	if (activePanelIsOpened === 'true') {
		panelToActivate
			.querySelector('button')
			.setAttribute('aria-expanded', false);

		panelToActivate
			.querySelector('.accordion-content')
			.setAttribute('aria-hidden', true);
	} else {
		panelToActivate
			.querySelector('button')
			.setAttribute('aria-expanded', true);

		panelToActivate
			.querySelector('.accordion-content')
			.setAttribute('aria-hidden', false);
	}
}

/* Width of content for scroll behavior for multicolumn */

document.addEventListener('DOMContentLoaded', () => {
  const liList = document.querySelectorAll('li.multicolumn-list__item');

  liList.forEach((li)=> {
    li.setAttribute("style", `--img-width: ${li.offsetWidth}px`);
  })
})


/*  */

const apoCustomSelectionsForestCoop = {};


function storeSelectionOption (parentId, selectedOption, label, isCheckboxType = false) {
  const match = label.match(/\+\$([\d,]+)/);

  if (match) {
    const priceStr = match[1].replace(/,/g, ''); // remove commas
    const priceInt = parseInt(priceStr, 10); // convert to integer (e.g., 8926)

    if (isCheckboxType) {
      apoCustomSelectionsForestCoop[parentId].push({
        value: selectedOption.value,
        text: priceInt,
        label: label.replace(/\s*\([^()]*\)\s*$/, '')
      })
    } else {
      apoCustomSelectionsForestCoop[parentId] = {
        value: selectedOption.value,
        text: priceInt,
        label: label.replace(/\s*\([^()]*\)\s*$/, '')
      }
    }
  } else {
    apoCustomSelectionsForestCoop[parentId] = {
      value: selectedOption.value,
      text: 0,
      label: label.replace(/\s*\([^()]*\)\s*$/, '')
    }
  }
}

function getSelectedAPOValues(container) {
  const selects = container.querySelectorAll('select');
  selects.forEach(select => {
    const parentId = select.closest('.mw-apo-option')?.dataset.optionTitle || select.name || select.id;
    
    const selectedOption = select.options[select.selectedIndex];

    storeSelectionOption(parentId, selectedOption, selectedOption.textContent.trim())
  });

  const radios = container.querySelectorAll('input[type="radio"]:checked');
  radios.forEach(radio => {
    const parentId = radio.closest('.mw-apo-option')?.dataset.optionTitle || radio.name;
    
    storeSelectionOption(parentId, radio, radio.parentElement.textContent.trim())
  });

  const checkboxGroupCleared = {}
  const checkboxes = container.querySelectorAll('input[type="checkbox"]');

  checkboxes.forEach(checkbox => {
    const parentId = checkbox.closest('.mw-apo-option')?.dataset.optionTitle || checkbox.name;

    if (!checkboxGroupCleared[parentId]) {
      apoCustomSelectionsForestCoop[parentId] = []
      checkboxGroupCleared[parentId] = true
    }
    
    if (checkbox.checked) {
      storeSelectionOption(parentId, checkbox, checkbox.parentElement.textContent.trim(), true)
    }
  });

  // const texts = container.querySelectorAll('input[type="text"], textarea');
  // texts.forEach(input => {
  //   const label = input.closest('.mw-apo-option')?.dataset.optionTitle || input.name;
  //   selections[label] = input.value;
  // });

}


let firstTimeApoRun = true;
let timesRun = 1;
let firstTimeApoRunBasePriceText = '';

function initApoOptionListener(container, currency) {
  const span = document.querySelector('.price-item');
  span.textContent = `$0.00 ${currency}`;
  const stickyDiv = document.querySelector('.inserted-sticky-price-item')
  if (stickyDiv) {
    stickyDiv.textContent = `$0.00 ${currency}`;
  }
  
  container.addEventListener('change', (event) => {
    const target = event.target;

    // You can filter if needed
    if (target.matches('select, input[type="radio"], input[type="checkbox"], input[type="text"], textarea')) {
      getSelectedAPOValues(container);

      const productsAdded = {};

      const total = Object.keys(apoCustomSelectionsForestCoop).reduce((accum, key) => {
        if (Array.isArray(apoCustomSelectionsForestCoop[key]) && apoCustomSelectionsForestCoop[key].length > 0) {
          return accum + apoCustomSelectionsForestCoop[key].reduce((accum, o) => accum + o.text, 0)
        } else if(apoCustomSelectionsForestCoop[key].text && apoCustomSelectionsForestCoop[key].label && !productsAdded[apoCustomSelectionsForestCoop[key].label]) {
          productsAdded[apoCustomSelectionsForestCoop[key].label] = true
          return accum + apoCustomSelectionsForestCoop[key].text
        }

        return accum
      }, 0)
      
      const span = document.querySelector('.price-item');
      const div = document.querySelector('.inserted-price-item');
      const formattedPrice = total.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      if (window.location.pathname.includes('cold-plunge')) {
        timesRun += 1;

        if (timesRun === 4) {
          firstTimeApoRunBasePriceText = `Starting from $${formattedPrice} ${currency}`;
        }
      } else {
        if (firstTimeApoRun) {        
          firstTimeApoRun = false;
          firstTimeApoRunBasePriceText = `Starting from $${formattedPrice} ${currency}`;
        }
      }

      span.textContent = firstTimeApoRunBasePriceText
      
      div.textContent = `$${formattedPrice} ${currency}`; 
      if (stickyDiv) {
        stickyDiv.textContent = `$${formattedPrice} ${currency}`; 
      }
    }
  });

  container.addEventListener('input', (event) => {
    const target = event.target;
    if (target.matches('input[type="text"], textarea')) {
      getSelectedAPOValues(container);
    }
  });
}

function normalizeSpaces(str) {
  return str.replace(/\s+/g, ' ').trim();
}

function updateApoDropdownPrices(container, currentCurrency) {
  const currencyToCountryMap = {
    "USD": "US",
    "CAD": "CA"
  };

  // Check if product title exists
  if (!window.mwApoInit?.product?.title) {
    console.error('Product title not available');
    return;
  }

  fetch('/apps/proxy-me/get-prices', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      country: currencyToCountryMap[currentCurrency],
      searchText: window.mwApoInit.product.title
    })
  })
  .then(response => response.json())
  .then(data => {
    const selects = container.querySelectorAll('select');

    selects.forEach(select => {
      const options = Array.from(select.querySelectorAll('option'));
  
      options
        .filter(o => {
          return o.textContent.toLowerCase().indexOf("please select") === -1;
        })
        .forEach(option => {
          const originalText = option.textContent.trim();

          const priceObject = data.prices.find((d) => {
            return originalText.indexOf(normalizeSpaces(d.title.replace(`${window.mwApoInit.product.title} - `, ''))) >= 0
              && d.title !== window.mwApoInit.product.title;
          });

          // Check if priceObject exists before using it
          if (priceObject && priceObject.price) {
            const updatedText = originalText.replace(
              /\(\+\$[\d,\.]+ (USD|CAD|[A-Z]{3})\)/,
              () => {
                const formattedAmount = new Intl.NumberFormat('en-US', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2
                }).format(Number(priceObject.price.amount));
                
                return `(+\$${formattedAmount} ${currentCurrency})`;
              }
            );

            option.textContent = updatedText;
          }
        });
    });

    const radios = container.querySelectorAll('input[type="radio"]');
    const checkboxes = container.querySelectorAll('input[type="checkbox"]');

    Array.from(radios).concat(Array.from(checkboxes))
      .filter(r => {
        return r.parentElement.textContent.toLowerCase().indexOf("none") === -1;
      })
      .forEach(radio => {
        const parentElement = radio.parentElement;
        const priceSpan = parentElement.querySelector('.mw-option__price');
        const originalText = parentElement.textContent.trim();

        const priceObject = data.prices.find((d) =>
          originalText.indexOf(d.title.replace(`${window.mwApoInit.product.title} - `, '')) >= 0
        );
    
        if (priceSpan && priceObject && priceObject.price) {
          const formattedAmount = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }).format(Number(priceObject.price.amount));
          
          priceSpan.textContent = `(+$${formattedAmount} ${currentCurrency})`;
        }
      });

      if (window.location.pathname.includes('cold-plunge')) {
        // Select the first 3 selects
        const selects = document.querySelectorAll('.mw-option__control--type-select');

        selects.forEach((select, index) => {
          if (index < 3) {
            select.selectedIndex = 1; // assuming index 0 is placeholder, index 1 is first real option
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } else {
        const firstSelect = document.querySelector('.mw-option__control--type-select');
        
        if (firstSelect) {
          firstSelect.selectedIndex = 1;
          firstSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // const firstSelect = document.querySelector('.mw-option__control--type-select');

      // if (firstSelect) {
      //   firstSelect.selectedIndex = 1;
      //   firstSelect.dispatchEvent(new Event('change', { bubbles: true }));
      // }

  })
  .catch(error => console.error('Error fetching prices', error));
}

function sanitizeChildProductTitle (parentTitle, childTitle) {
  return childTitle.replace(`${parentTitle} -`, '').trim()
}

function parseCartItems (parentItem, cart) {
  const childItems = parentItem.properties._mws_products.split(";")

  const childItemIdsAndCounts = childItems.map((item) => {
    const split = item.split(",")
    return {
      id: parseInt(split[1]),
      count: parseInt(split[2])
    }
  })

  const { items: newLineItems, totalPrice, checkOutItems } = cart.items.reduce((accum, item) => {

    const childItemIdAndCount = childItemIdsAndCounts.find(obj => obj.id === parseInt(item.id))

    if (
      item.id &&
      childItemIdAndCount &&
      !accum.childItemsAddedToCurrentParent[item.product_title]
    ) {
      accum.childItemsAddedToCurrentParent[item.product_title] = true;
      accum.items.push({ id: item.id, type: item.product_type, price: item.price, product: item.product_title, quantityAbsorbedIntoPrice: childItemIdAndCount.count })
      accum.totalPrice += (item.price * childItemIdAndCount.count)
      const sanitizedKey = (item.product_type === 'Add-on') ? `${item.product_type} ${accum.addOnCount}` : item.product_type;
      if (item.product_type === 'Add-on') {
        accum.addOnCount = accum.addOnCount + 1;
      } 
      
      if (!accum.checkOutItems[parentItem.key]) {
        accum.checkOutItems[parentItem.key] = {
          product: parentItem.title + ' - ' + sanitizeChildProductTitle(parentItem.title, item.product_title),
          lineItems: [{ key: sanitizedKey, value: sanitizeChildProductTitle(parentItem.title, item.product_title), price: `$${(item.price / 100).toFixed(0)}` }],
          itemCount: childItemIdAndCount.count,
          itemPrice: item.price
        }
      } else {
        accum.checkOutItems[parentItem.key].itemPrice += item.price
        accum.checkOutItems[parentItem.key].lineItems.push({ key: sanitizedKey, value: sanitizeChildProductTitle(parentItem.title, item.product_title), price: `$${(item.price / 100).toFixed(0)}` })
        accum.checkOutItems[parentItem.key].product += ', ' + sanitizeChildProductTitle(parentItem.title, item.product_title)
      }
    }
    return accum
  }, { items: [], totalPrice: 0, checkOutItems: {}, addOnCount: 1, childItemsAddedToCurrentParent: {} });

  if (parentItem.price !== 0) {
    checkOutItems[parentItem.key].itemPrice += parentItem.price
  }

  return {
    newLineItems,
    totalPrice,
    parentItem,
    checkOutItems
  }
}

function removeProductOptionSiblings (element, container, targetClass) {
  if (!element) return;
  Array.from(element.children).forEach(child => {
    if (child !== container && child.classList.contains(targetClass)) {
      child.remove();
    }
  });
};

function appendNewLineItem (container, productKey, item) {
  const row = document.createElement('tr');
  
  const keyCell = Object.assign(document.createElement('td'), {
    className: 'product-option-key',
    textContent: item.product
  });
  
  const priceCell = Object.assign(document.createElement('td'), {
    className: 'product-option-price',
    textContent: `$${(item.price / 100).toFixed(0)}`
  });

  row.appendChild(keyCell);
  row.appendChild(priceCell);
  
  container.appendChild(row);
}

function addTotalColumn (rowContainer, parentItem) {
  const existingTotals = rowContainer.querySelectorAll('td.cart-item__totals')
  existingTotals.forEach((totalsCell) => {
    totalsCell.remove()
  });

  const td = document.createElement('td');
  td.className = 'cart-item__totals right small-hide';
  td.innerHTML = `
    <div class="cart-item__price-wrapper">
      <span data-hulkapps-line-price="" data-total-key="${parentItem.key}" data-cart-id="${parentItem.properties._mws_cart}" class="price price--end"></span>
    </div>
  `;
  rowContainer.appendChild(td);
}

function updateTotalPrice(parentItem, totalPrice) {
  document.querySelectorAll(`[data-total-key="${parentItem.key}"]`).forEach(el => {
    const moneyEl = el.querySelector('.transcy-money');
    const formattedPrice = `$${(totalPrice / 100).toFixed(2)}`;

    if (moneyEl) {
      moneyEl.textContent = formattedPrice;
    } else {
      el.textContent = formattedPrice;
    }
  });
}

function clearContainersProductOptions (container) {
  // clear all container's parent and grandparent children .product-option elements (basically any apo product native line items)
  container.innerHTML = '';
  if (container) {
    removeProductOptionSiblings(container.parentNode, container, 'product-option');
    removeProductOptionSiblings(container.parentNode?.parentNode, container, 'product-option');
  }
}

function updateCart () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const parentItems = cart.items.filter(item => 
        item.properties && item.properties._mws_products);
      
      document.querySelectorAll('div[data-hulkapps-ci-price]').forEach(el => {
        el.style.display = 'none';
      });

      parentItems.forEach(parentItem => {
        const { newLineItems, totalPrice: totalPriceAfterParsing } = parseCartItems(parentItem, cart)

        let totalPrice = totalPriceAfterParsing

        // find the corresponding cart item row and store data-hulkapps-line-properties element as container for new product lines
        let container = document.querySelector(`span[data-key="${parentItem.key}"]`).closest('tr').querySelector('[data-hulkapps-line-properties]');

        // Create the new table
        const newTable = document.createElement('table');
        
        // Append the new table under the original container
        container.appendChild(newTable);
        
        // Reassign `container` to point to the new table
        container = newTable;
        
        clearContainersProductOptions(container)

        // if the parent price for some reason is not 0, include it as a product line as well
        if (parentItem.price !== 0) {
          totalPrice += parentItem.price * newLineItems[0].quantityAbsorbedIntoPrice
          appendNewLineItem(container, 'product_title', parentItem)
        }

        // hide all child cart items and append them to appropriate parent item
        newLineItems.sort((a, b) => b.price - a.price).map((newLineItem) => {
          // hide item child item
          document.querySelectorAll(`[data-mw-apo-variant-id="${newLineItem.id}"]`).forEach(el => {
            el.closest('tr')?.style.setProperty('display', 'none', 'important');
          });

          // append new child line item to parent
          newLineItem.product = newLineItem.product.replace(`${parentItem.product_title} - `, '')
          appendNewLineItem(container, 'product', newLineItem)
        })

        const rowContainer = document.querySelector(`span[data-key="${parentItem.key}"]`).closest('tr');
        if (rowContainer) {
          addTotalColumn(rowContainer, parentItem)
        }

        // update total prices
        updateTotalPrice(parentItem, totalPrice)
      })
    })
    .catch(error => console.error('Error fetching cart:', error))
    .finally(() => {
      document.querySelector('.cart__items').classList.remove('visually-hidden');
    })
}

let currentCurrency = null
let currentCurrencyPrices = null

function insertPricingDivs() {
  const priceSelector = '.price-item.price-item--regular';
  const buttonsSelector = '.product-form__buttons';
  const productFormButtons = document.querySelector(buttonsSelector);
  const priceElement = document.querySelector(priceSelector);
  
  if (!priceElement) return;
  if (!productFormButtons) return;

  // Avoid inserting multiple times
  if (document.querySelector('.inserted-price-item')) return;

  const newDiv = document.createElement('div');
  newDiv.className = 'inserted-price-item';
  newDiv.style.fontSize = '1.8rem';
  newDiv.style.marginTop = '10px';
  newDiv.style.marginBottom = '10px';
  newDiv.textContent = priceElement.textContent;
  productFormButtons.parentNode.insertBefore(newDiv, productFormButtons);

  if (document.querySelector('.inserted-sticky-price-item')) return;
  const stickyHeader = document.querySelector('sticky-header');
  const newStickyDiv = document.createElement('div');

  // Apply the styles
  Object.assign(newStickyDiv.style, {
    position: 'absolute',
    right: '0',
    background: 'black',
    paddingRight: '20px',
    paddingLeft: '20px',
    borderBottomLeftRadius: '10px',
    display: 'none'
  });
  
  // Optionally add some content
  newStickyDiv.textContent = 'test';
  newStickyDiv.className = 'inserted-sticky-price-item'
  
  // Append the new div at the end of sticky-header
  stickyHeader.appendChild(newStickyDiv);
}

function adjustHomePageSecondSliderPadding() {
    if (window.location.pathname !== '/') return;

    const sliders = document.querySelectorAll('slider-component');
    const secondSlider = sliders[1];

    if (secondSlider) {
      secondSlider.querySelectorAll('.media.media--adapt').forEach(el => {
        if (window.innerWidth >= 3000) {
          el.style.paddingBottom = '50%';
        } else if (window.innerWidth >= 2400) {
          el.style.paddingBottom = '70%';
        } else {
          el.style.paddingBottom = '100%';
        }
      });
    }
  }

document.addEventListener('DOMContentLoaded', async () => {
  // ADDED AS PER LORNE TO REMOVE CART PAGE AND REDIRECT HOME
  if (window.location.pathname === '/cart') {
    window.location.replace('/');
  }


  document.querySelector('shop-follow-button')?.remove();

  const currencyToCountryMap = {
    "USD": "US",
    "CAD": "CA"
  }
  
  const ipapiObject = await fetch('https://ipinfo.io/json?token=9d6c0decb21c0b')
  const geoLocation = await ipapiObject.json()
  
  if (geoLocation && geoLocation.country) {
    console.log('country', geoLocation.country)
  }
  
  currentCurrency = geoLocation && geoLocation.country === 'CA' ? 'CAD' : 'USD'
  
  const observer = new MutationObserver((mutations, obs) => {
    const apoContainer = document.querySelector('.mw-apo-container');
    
    if (apoContainer) {
      apoContainer.insertAdjacentHTML('beforeend',
        `<div style="font-size: 15px; margin-top: 10px">
          <span style="color: var(--mw-apo-color-danger, #de3618)">*</span><span style="color: black;"> - required<span>
        </div>`
      );

      insertPricingDivs();
      initApoOptionListener(apoContainer, currentCurrency);
      updateApoDropdownPrices(apoContainer, currentCurrency);

      obs.disconnect(); // Stop observing
    }

    // remove odd tooltip attributes
    const buggyTooltips = document.querySelectorAll('[data-mw-tooltip="The actual price in the cart may vary slightly due to conversion rate fluctuations"]')
      
    if (buggyTooltips) {
      buggyTooltips.forEach(el => {
        el.removeAttribute('data-mw-tooltip');
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (document.querySelector('slider-component')) { // home page 
    function resizeImagesIfNeeded() {
      if (window.innerWidth > 1350) {
        document.querySelectorAll('.column-behavior-on_hover_show .multicolumn-list__item img').forEach(function(img) {
          img.style.width = '230px';
          img.style.height = '230px';
        });


        if (window.innerWidth > 1900) {
          document.querySelectorAll('.multicolumn-card__image-wrapper + .multicolumn-card__info').forEach(function(el) {
            el.style.marginTop = '-100px';
          });          
        } else if (window.innerWidth > 1700) {
          document.querySelectorAll('.multicolumn-card__image-wrapper + .multicolumn-card__info').forEach(function(el) {
            el.style.marginTop = '-50px';
          });    
        } else {
          document.querySelectorAll('.multicolumn-card__image-wrapper + .multicolumn-card__info').forEach(function(el) {
            el.style.marginTop = '-20px';
          });    
        }
      } else {
        document.querySelectorAll('.column-behavior-on_hover_show .multicolumn-list__item img').forEach(function(img) {
          img.style.width = '';
          img.style.height = '';
        });
        document.querySelectorAll('.multicolumn-card__image-wrapper + .multicolumn-card__info').forEach(function(el) {
          el.style.marginTop = '';
        });
      }
    }
    
    // Run on page load
    resizeImagesIfNeeded();
    
    // Optional: Run on resize
    window.addEventListener('resize', resizeImagesIfNeeded);
  }

  adjustHomePageSecondSliderPadding();

  window.addEventListener('resize', adjustHomePageSecondSliderPadding);

  
  if (window.location.pathname === '/cart') {
    const taxNote = document.querySelector(".us-tax-note");

    if (currentCurrency === "CAD") {
      taxNote.style.display = "none";
    } else {
      taxNote.style.display = "block";
    }

    // Select the element
    const totalValueEl = document.querySelector('.totals > .totals__total-value');
    
    // Perform regex to replace total currency on cart page
    if (totalValueEl) {
      totalValueEl.textContent = totalValueEl.textContent.replace(
        /(\$\s*\d[\d,\.]*)\s*[A-Z]{3}\b/,
        `$1 ${currentCurrency}`
      );
    }

    document.querySelectorAll('a').forEach(function(link) {
      if (link.textContent.trim() === 'Edit Options') {
        link.style.display = 'none'
      }
    });
    
    updateCart()
  }

  // const productForm = document.querySelector('product-form');

  // if (productForm) {
  //   let productName = ''
  //   if (window.location.pathname === '/products/cold-plunge') {
  //     productName = "cold plunge"
  //   } else if (window.location.pathname === '/products/cedar-soaker-tub') {
  //     productName = "soaker tub"
  //   } else if (window.location.pathname === '/products/hot-tub-1') {
  //     productName = "hot tub"
  //   } else if (window.location.pathname === '/products/sauna') {
  //     productName = "sauna"
  //   } else if (window.location.pathname === '/products/cistern') {
  //     productName = "cistern"
  //   }

  //   const paymentTermText = `To secure your ${productName}, a 50% deposit is required at the time of purchase. The remaining 50% will be due one week before shipping.`
    
  //   // Create wrapper div
  //   const wrapperDiv = document.createElement('div');
  //   wrapperDiv.className = 'custom-message';
  //   wrapperDiv.style.marginTop = '15px'

  //   // Create header div
  //   const headerDiv = document.createElement('div');
  //   headerDiv.className = 'custom-message__header';
  //   headerDiv.textContent = 'Payment Terms';

  //   // Create description div
  //   const descriptionDiv = document.createElement('div');
  //   descriptionDiv.className = 'custom-message__description';
  //   descriptionDiv.textContent = paymentTermText;
  //   descriptionDiv.style.color = 'black'

  //   // Append inner divs to wrapper
  //   wrapperDiv.appendChild(headerDiv);
  //   wrapperDiv.appendChild(descriptionDiv);

  //   // Insert wrapper after <product-form>
  //   productForm.parentNode.insertBefore(wrapperDiv, productForm.nextSibling);
  // }

  if (window.location.pathname.indexOf('collections') >= 0 && window.location.pathname !== '/collections/frontpage') {
    window.location.replace('/collections/frontpage');
  }

  if (window.location.pathname.indexOf('/blogs/news') >= 0) {
    document.querySelectorAll('time').forEach(el => el.style.display = 'none');
  }

  const productFormEl = document.querySelector('.product__title');
  if (window.location.pathname.indexOf('cold-plunge') >= 0) {
    const drawingsHtml = `
    <span class="mw-text mw-text--style-strong" style="color: rgb(var(--color-foreground)); margin-top: -20px; font-size: calc(var(--font-heading-scale) * 1.8rem);">Cold Plunge Drawings</span>
    <div class="tub-drawings">
      <span
        onclick="window.open('https://cdn.shopify.com/s/files/1/0713/4904/3506/files/Cold_Plunge_Tubs.pdf?v=1753386025', '_blank')"
        class="mw-text mw-text--style-strong" style="color: blue; margin-top: -20px; text-decoration: underline; cursor: pointer;">
        1 person and 2 person
      </span>
      <span
        onclick="window.open('https://cdn.shopify.com/s/files/1/0713/4904/3506/files/4-Diameter-Cold-Plunge.pdf?v=1753385660', '_blank')"
        class="mw-text" style="color: blue; margin-top: -20px; text-decoration: underline; cursor: pointer;margin-left: 10px;">4' Diameter
      </span>
    </div>
    `;
    if (productFormEl) {
      productFormEl.insertAdjacentHTML('afterend', drawingsHtml);
    }
  } else if (window.location.pathname.indexOf('cedar-soaking-tub') >= 0) {
    const drawingsHtml = `
    <span class="mw-text mw-text--style-strong" style="color: rgb(var(--color-foreground)); margin-top: -20px; font-size: calc(var(--font-heading-scale) * 1.8rem);">Cedar Japanese Soaking Tub Drawings</span>
    <div class="tub-drawings">
      <span
        onclick="window.open('https://cdn.shopify.com/s/files/1/0713/4904/3506/files/Soaking_Tubs_2025.pdf?v=1759508918', '_blank')"
        class="mw-text mw-text--style-strong" style="color: blue; margin-top: -20px; text-decoration: underline; cursor: pointer;">
        1 person and 2 person
      </span>
      <span
        onclick="window.open('https://cdn.shopify.com/s/files/1/0713/4904/3506/files/4-Diameter-Soaking-Tubs.pdf?v=1753385662', '_blank')"
        class="mw-text" style="color: blue; margin-top: -20px; text-decoration: underline; cursor: pointer;margin-left: 10px;">4' Diameter
      </span>
    </div>
    `;
    if (productFormEl) {
      productFormEl.insertAdjacentHTML('afterend', drawingsHtml);
    }
  } else if (window.location.pathname.indexOf('cedar-hot-tub') >= 0) {
    const drawingsHtml = `
    <span class="mw-text mw-text--style-strong" style="color: rgb(var(--color-foreground)); margin-top: -20px; font-size: calc(var(--font-heading-scale) * 1.8rem);">Hot Tub Drawings</span>
    <div class="tub-drawings">
      <span
        onclick="window.open('https://cdn.shopify.com/s/files/1/0713/4904/3506/files/5-Diameter-Hot-Tubs.pdf?v=1751086376', '_blank')"
        class="mw-text" style="color: blue; margin-top: -20px; text-decoration: underline; cursor: pointer;">5' Diameter
      </span>
      <span
        onclick="window.open('https://cdn.shopify.com/s/files/1/0713/4904/3506/files/6-Diameter-Hot-Tubs.pdf?v=1751086376', '_blank')"
        class="mw-text" style="color: blue; margin-top: -20px; text-decoration: underline; cursor: pointer; margin-left: 10px;">6' Diameter
      </span>
      <span
        onclick="window.open('https://cdn.shopify.com/s/files/1/0713/4904/3506/files/7-Diameter-Hot-Tubs.pdf?v=1751086376', '_blank')"
        class="mw-text" style="color: blue; margin-top: -20px; text-decoration: underline; cursor: pointer; margin-left: 10px;">7' Diameter
      </span>
    </div>
      `;
    if (productFormEl) {
      productFormEl.insertAdjacentHTML('afterend', drawingsHtml);
    }
  }  else if (window.location.pathname.indexOf('barrel-cedar-sauna') >= 0) {
    const drawingsHtml = `
    <span class="mw-text mw-text--style-strong" style="color: rgb(var(--color-foreground)); margin-top: -20px; font-size: calc(var(--font-heading-scale) * 1.8rem);">Sauna Drawings</span>
    <div class="tub-drawings">
      <span
        onclick="window.open('https://cdn.shopify.com/s/files/1/0713/4904/3506/files/6.5-Diameter-Saunas_c649f6e7-fdbb-4f8f-a2af-0af11c0bb5ac.pdf?v=1760625613', '_blank')"
        class="mw-text" style="color: blue; margin-top: -20px; text-decoration: underline; cursor: pointer;">6.5' Diameter
      </span>
      <span
        onclick="window.open('https://cdn.shopify.com/s/files/1/0713/4904/3506/files/7-Diameter-Saunas.pdf?v=1751086376', '_blank')"
        class="mw-text" style="color: blue; margin-top: -20px; text-decoration: underline; cursor: pointer; margin-left: 10px;">7' Diameter
      </span>
    </div>
      `;
    if (productFormEl) {
      productFormEl.insertAdjacentHTML('afterend', drawingsHtml);
    }
  }
  
  if (window.location.pathname === '/collections/frontpage') {
    document.querySelectorAll('.card__inner').forEach((el, index) => {
      el.classList.add(`frontpage-${index}`);
    });

    const formatPrice = (input) => {
      const number = parseFloat(input);
      if (isNaN(number)) return 'Invalid price';
    
      return `From ${number.toLocaleString('en-US', { style: 'currency', currency: currentCurrency })}`;
    }
    
    const productTitles = [
      `Cedar Hot Tub - 5' x 3'`,
      'Cedar Cold Plunge - 1 Person Cedar Cold Plunge',
      'Soaker Tub - 1 person',
      'Sauna - 6.5 x 5',
      `Cistern - 550 Gallon (5'x5')`,
    ]

    const productTitleMap = {
      "Cedar Hot Tub": `Cedar Hot Tub - 5' x 3'`,
      "Cedar Cold Plunge": 'Cedar Cold Plunge - 1 Person Cedar Cold Plunge',
      "Soaker Tub": 'Soaker Tub - 1 person',
      "Sauna": 'Sauna - 6.5 x 5',
      "Cistern": `Cistern - 550 Gallon (5'x5')`,
    }
    
    fetch('/apps/proxy-me/get-product-prices', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        country: currencyToCountryMap[currentCurrency],
        productTitles
      })
    })
    .then(response => response.json())
    .then(data => {
      document.querySelectorAll('.card__content').forEach(card => {
        const titleElement = card.querySelector('.card__heading a');
        const baseAmountProductTitle = productTitleMap[titleElement.textContent.trim()]
        const baseAmount = baseAmountProductTitle ? data.prices.find(pObject => pObject.title === baseAmountProductTitle) : undefined
        if (titleElement &&
           baseAmountProductTitle &&
           baseAmount) {
          const priceWrapper = card.querySelector('.price-item.price-item--regular');
    
          if (priceWrapper) {
            priceWrapper.textContent = '';
            const span = document.createElement('span');
            span.className = 'transcy-money';
            span.textContent = `${formatPrice(baseAmount.price.amount)} ${currentCurrency}`;
            priceWrapper.appendChild(span);
          }
        }
      });
    })
    
  } else if (window.location.pathname === '/cart') {
    const checkoutBtn = document.getElementById('checkout');

    if (checkoutBtn) {
      checkoutBtn.setAttribute('data-micromodal-trigger', 'simple-modal');
      checkoutBtn.addEventListener('click', async function (e) {
        e.preventDefault(); // Stop Shopify's default checkout
      });
    }

    const confirmCheckoutButton = document.getElementById('checkout-confirm-button');

    if (confirmCheckoutButton) {
      confirmCheckoutButton.addEventListener('click', async function (e) {
        // Optional: Disable the button to prevent double clicks
        confirmCheckoutButton.disabled = true;
        confirmCheckoutButton.innerText = 'Processing...';

        try {
          // Fetch cart data (or replace with custom logic)
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();

          const parentItems = cart.items.filter(item => 
            item.properties && item.properties._mws_products);

          let cartItemsForCheckout = []
          parentItems.forEach(parentItem => {
            const { checkOutItems } = parseCartItems(parentItem, cart)

            cartItemsForCheckout = [
              ...cartItemsForCheckout,
              ...Object.keys(checkOutItems).map(parentKey => {
                return {
                  product: checkOutItems[parentKey].product,
                  lineItems: checkOutItems[parentKey].lineItems,
                  itemCount: checkOutItems[parentKey].itemCount,
                  itemPrice: (checkOutItems[parentKey].itemPrice / 2 / 100).toFixed(2), // 50% deposit so divide by 2
                  itemFullPrice: (checkOutItems[parentKey].itemPrice / 100).toFixed(2)
                }
              })
            ]
          })
          
          const selectedCurrency = currentCurrency; // or whatever currency the user is browsing in

          fetch('/apps/proxy-me/create-draft-order', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              cart: cartItemsForCheckout, // Array of cart items
              parentKey: 'your-parent-key', // Any other required info
              selectedCurrency: selectedCurrency
            })
          })
          .then(response => response.json())
          .then(data => {
            confirmCheckoutButton.disabled = false;
            confirmCheckoutButton.innerText = "Got it — Let’s Checkout";
            // Redirect user to the invoice_url
            MicroModal.close('simple-modal')
            window.location.href = data.checkout_url;
          })
          .catch(error => console.error('Error creating draft order:', error));
        } catch (err) {
          console.error('Error creating draft order:', err);
        } finally {
          // checkoutBtn.disabled = false;
          // checkoutBtn.innerText = 'Check out';
        }
      })
    }

    function sendQuoteEmail({ cart, selectedCurrency, email }) {
      fetch('/apps/proxy-me/email-draft-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          cart,
          parentKey: 'your-parent-key',
          selectedCurrency,
          customerEmail: email
        })
      })
        .then(response => response.json())
        .then(data => {
          console.log("Server response:", data);
        })
        .catch(error => console.error('Error sending draft order email:', error));
    }

    const wrapper = document.querySelector(".title-wrapper-with-link");

    if (wrapper && window.location.pathname.indexOf('/cart') >= 0) {
      // --- 1. Inject our new structure ---
      wrapper.innerHTML = `
        <h1 class="title title--primary">Your cart</h1>
        <div class="cart-quote-link-group">
          <a href="#" class="cart-quote-link cart-quote-link--trigger">Email myself a Quote</a>
          <a href="/collections/frontpage" class="cart-quote-link cart-quote-link--continue">Continue shopping</a>
        </div>
      `;

      const quoteLink = wrapper.querySelector(".cart-quote-link--trigger");
      const linkGroup = wrapper.querySelector(".cart-quote-link-group");

      // --- 2. When clicked, replace link with email input + send button ---
      quoteLink.addEventListener("click", (e) => {
        e.preventDefault();

      linkGroup.innerHTML = `
        <div class="cart-quote-email-form">
          <input 
            type="email" 
            placeholder="Enter your email" 
            class="cart-quote-email-input" 
          />
          <button type="button" class="cart-quote-send-btn" aria-label="Send Quote">
            ➤
          </button>
        </div>
        <a href="/collections/frontpage" class="cart-quote-link cart-quote-link--continue">Continue shopping</a>
      `;

        const sendBtn = linkGroup.querySelector(".cart-quote-send-btn");
        const emailInput = linkGroup.querySelector(".cart-quote-email-input");

        sendBtn.addEventListener("click", async (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();

          try {
            // Fetch cart data (or replace with custom logic)
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();

            const parentItems = cart.items.filter(item => 
              item.properties && item.properties._mws_products);

            let cartItemsForCheckout = []
            parentItems.forEach(parentItem => {
              const { checkOutItems } = parseCartItems(parentItem, cart)

              cartItemsForCheckout = [
                ...cartItemsForCheckout,
                ...Object.keys(checkOutItems).map(parentKey => {
                  return {
                    product: checkOutItems[parentKey].product,
                    lineItems: checkOutItems[parentKey].lineItems,
                    itemCount: checkOutItems[parentKey].itemCount,
                    itemPrice: (checkOutItems[parentKey].itemPrice / 2 / 100).toFixed(2), // 50% deposit so divide by 2
                    itemFullPrice: (checkOutItems[parentKey].itemPrice / 100).toFixed(2)
                  }
                })
              ]
            })

            const selectedCurrency = currentCurrency; // or whatever currency the user is browsing in
            
            sendQuoteEmail({
              cart: cartItemsForCheckout,
              selectedCurrency,
              email: emailInput.value
            })
          } catch (err) {
            console.error('Error emailing draft order:', err);
          } finally {
            // checkoutBtn.disabled = false;
            // checkoutBtn.innerText = 'Check out';
          }
          
        });
      });
    }

    // Get all elements with the class 'us-tax-note'
    const taxNotes = document.querySelectorAll('.us-tax-note');

    if (taxNotes.length > 0) {
      // Replace the text in the first one
      taxNotes[0].textContent = "Shipping is flat-rate to most Canadian locations and the lower 48 U.S. states. Remote areas and international destinations require a custom shipping quote. Lead time is about 12 weeks.";
    }

    // Remove the second one, if it exists
    if (taxNotes.length > 1) {
      taxNotes[1].remove();
    }

    function disablePageScroll() {
      // Save the current scroll position
      document.body.dataset.scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    }

    function enablePageScroll() {
      const scrollY = document.body.dataset.scrollY;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(scrollY || '0'));
    }

    // Otherwise, observe DOM until it's available
    const observer = new MutationObserver(() => {
      if (window.MicroModal && typeof MicroModal.show === 'function') {
        observer.disconnect();
        MicroModal.init({
          disableScroll: true,
          closeOnOverlayClick: false,
          onShow: modal => {
            disablePageScroll();
            
            const overlay = modal.querySelector('.modal__cart-overlay');
            const container = modal.querySelector('.modal__cart-container');
        
            overlay.addEventListener('click', function (e) {
              // Get the visual bounding box of the modal container
              const bounds = container.getBoundingClientRect();
        
              // Check if the click was outside the modal box
              const clickedOutside =
                e.clientX < bounds.left ||
                e.clientX > bounds.right ||
                e.clientY < bounds.top ||
                e.clientY > bounds.bottom;
        
              if (clickedOutside) {
                MicroModal.close(modal.id);
              }
            });
          },
          awaitCloseAnimation: false, // optional, turn off if you're not animating
          onClose: () => {
            // Optionally return focus to a known element like body or a trigger button
            document.activeElement.blur(); // this line prevents focus conflict
            enablePageScroll();
          }
        });

        const confirmBookButton = document.getElementById("checkout-book-button");
        if (confirmBookButton) {
          confirmBookButton.addEventListener("click", function() {
            window.open("https://calendly.com/forestcooperage/15min", "_blank");
          });
        }
      }
    });

    // Observe document for script injections or new globals
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Failsafe timeout (stop after 10s to prevent infinite observe)
    setTimeout(() => observer.disconnect(), 10000);
    
  }

  // product warranty section, remove center'ness
  const section = document.querySelector("#shopify-section-template--22516847411506__rich_text_VdycCJ");
  
  if (section) {
    const richTextBlock = section.querySelector(".rich-text__blocks.center");
    if (richTextBlock) {
      richTextBlock.classList.remove("center");
    }
  }

  if (!document.getElementById("hide-calendly")) {
    const closeBtn = document.createElement("button");
    closeBtn.innerText = "×";
    closeBtn.id = "hide-calendly";
    closeBtn.setAttribute("aria-label", "Hide Calendly button");
    closeBtn.style.display = "none";
    // Insert at top of <body>
    document.body.insertBefore(closeBtn, document.body.firstChild);
    
    closeBtn.addEventListener("click", () => {
      const calendlyWidget = document.querySelector(".calendly-badge-widget");
      if (calendlyWidget) {
        calendlyWidget.style.opacity = "0";
        calendlyWidget.style.transform = "translateY(10px)";
        setTimeout(() => {
          calendlyWidget.style.display = "none";
        }, 300);
      }
      closeBtn.style.opacity = "0";
      closeBtn.style.transform = "translateY(-10px)";
      setTimeout(() => {
        closeBtn.style.display = "none";
      }, 300);
    });
  }
  
  let inView1 = false;
  let inView2 = false;
  let inView3 = false;
  
  const checkVisibility = () => {
    const sticky = document.querySelector('.inserted-sticky-price-item');
    // if (inView1 || inView2 || inView3) {
    //   sticky.style.display = 'none';
    // } else {
      sticky.style.display = 'block';
    // }
  };
  
  // Select the elements to observe
  const target1 = document.querySelector('.product__description');
  const target2 = document.querySelector('.price-item');
  const target3 = document.querySelector('.inserted-price-item');
  
  const intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.target.classList.contains('product__description')) {
        inView1 = entry.isIntersecting;
      }
      if (entry.target.classList.contains('price-item')) {
        inView2 = entry.isIntersecting;
      }
      if (entry.target.classList.contains('inserted-price-item')) {
        inView3 = entry.isIntersecting;
      }
    });

    const sticky = document.querySelector('.inserted-sticky-price-item');
    if (sticky) {
      checkVisibility();
    }
  }, {
    root: null,
    threshold: 0,
    rootMargin: '-100px 0px 0px 0px' // adjust this to match your header height
  });

  if (target1) intersectionObserver.observe(target1);
  if (target2) intersectionObserver.observe(target2);
  if (target3) intersectionObserver.observe(target3);

  const cartIcon = document.querySelector('.header__icon--cart')
  const cartNotificationIcon = document.querySelector('#cart-notification-button')
  if (cartIcon) {
    cartIcon.addEventListener('click', function(event) {
      event.preventDefault(); // optional: prevents default if it's a link
      window.location.href = `/cart?currency=${currentCurrency}`;
    });
  }
  if (cartNotificationIcon) {
    cartNotificationIcon.addEventListener('click', function(event) {
      event.preventDefault(); // optional: prevents default if it's a link
      window.location.href = `/cart?currency=${currentCurrency}`;
    });
  }

  setTimeout(() => {
    const calendlyWidget = document.querySelector(".calendly-badge-widget");
    if (calendlyWidget) {
      calendlyWidget.style.display = "inline";  
    }
    
    const hideCalendly = document.getElementById("hide-calendly")
    if (hideCalendly) {
      hideCalendly.style.display = "inline";  
    }
  }, 30000);

  if (window.location.pathname.indexOf('shipping') >= 0) {
    const elements = document.querySelectorAll('p > a'); // or 'div', '.class-name', etc.

    const match = Array.from(elements).find(el =>
      el.textContent.trim().toLowerCase() === 'contact us'
    );
    
    if (match) {
      match.setAttribute('href', '/pages/contact');
    }
  }

  const accleratedCheckoutButtons = document.querySelector('shopify-accelerated-checkout-cart')

  if (accleratedCheckoutButtons) {
    accleratedCheckoutButtons.remove()
  }

  if (window.location.pathname === '/') {
    document.querySelectorAll(".banner__heading").forEach(header => {
      const wrapper = document.createElement("div");
      wrapper.classList.add("landing-page-header-wrapper");

      header.parentNode.insertBefore(wrapper, header);
      wrapper.appendChild(header);
    });

    // Add extra class to .banner__content elements
    document.querySelectorAll(".banner__content").forEach(content => {
      content.classList.add("landing-page-banner-content");
    });

    const cardContainers = document.querySelectorAll('.multicolumn-list .multicolumn-list__item');

    cardContainers.forEach(cardContainer => {
      if (window.innerWidth <= 767) {
        // Mobile behavior here
        const card = cardContainer.querySelector('.multicolumn-card__info')
        const originalLink = card.querySelector('a');
        const rte = card.querySelector('.rte');

        if (card && originalLink && rte) {
          const link = originalLink.cloneNode(true);

          card.insertBefore(link, rte);
          rte.remove()
          const span = link.querySelector('span');

          card.style.opacity = '1';
          link.style.opacity = '1';
          link.style.display = 'block'
          link.style.fontSize = '3.25rem';
          link.style.padding = '0.5rem 1rem';
          link.style.display = 'inline-block';
          link.style.fontWeight = 'bold';
          link.style.textDecoration = 'none';

          originalLink.style.opacity = '1';
          originalLink.style.display = 'block';

          const originalText = originalLink.textContent.trim();
          originalLink.textContent = 'View ' + originalText;

          originalLink.appendChild(span);
        }
      } else {
        const card = cardContainer.querySelector('.multicolumn-card__info')
        const originalLink = card.querySelector('a');
        const rte = card.querySelector('.rte');

        if (card && originalLink && rte) {
          const link = originalLink.cloneNode(true);
          card.insertBefore(link, rte);

          const span = link.querySelector('span');

          card.style.opacity = '1';
          link.style.opacity = '1';
          link.style.fontSize = '3.25rem';
          link.style.padding = '0.5rem 1rem';
          link.style.display = 'inline-block';
          link.style.fontWeight = 'bold';
          link.style.textDecoration = 'none';
          rte.style.opacity = '0';
          rte.style.transition = 'opacity 0.3s ease';
          originalLink.style.opacity = '0';
          originalLink.style.transition = 'opacity 0.3s ease';
          const originalText = originalLink.textContent.trim();
          originalLink.textContent = 'View ' + originalText;

          originalLink.appendChild(span);
          
          cardContainer.addEventListener('mouseenter', () => {
            rte.style.opacity = '1';
            originalLink.style.opacity = '1';
          });

          cardContainer.addEventListener('mouseleave', () => {
            rte.style.opacity = '0';
            originalLink.style.opacity = '0';
          });
        }
      }
    });
  }

  if (window.location.pathname === '/products') {
    window.location.href = 'https://forestcooperage.com/collections/frontpage';
  }

  if (/^\/pages\/contact\/?$/.test(window.location.pathname)) {
    const contactForm = document.querySelector('form[action^="/contact"]');
    if (!contactForm) return;

    const contactSection = contactForm.closest('.shopify-section');
    if (!contactSection) return;

    // Find rich text section containing the header
    const richTextSection = Array.from(
      document.querySelectorAll('.shopify-section.section')
    ).find(section =>
      section.querySelector('.rich-text__heading') &&
      section.textContent.includes('How to Reach Us')
    );

    if (!richTextSection) return;

    const howToReachHeader = richTextSection.querySelector('.rich-text__heading');
    if (!howToReachHeader) return;

    howToReachHeader.style.display = 'flex';
    howToReachHeader.style.justifyContent = 'center';

    contactForm.parentNode.insertBefore(
      howToReachHeader,
      contactForm
    );

    richTextSection.parentNode.insertBefore(
      contactSection,
      richTextSection
    );

    richTextSection.style.marginTop = '-50px';
  }

})